import React, { useState } from 'react'
import { Alert, App, Spin, Form, Tabs } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { fetchQuestionsSelectors } from '../../../../../store/apis/utils/selectors/question.api.selectors'
import { useParams } from 'react-router'
import { questionActions } from '../../../../../store/slices/question.slice'
import ResizableDrawer from '../../../../../components/common/resizable-drawer/ResizableDrawer'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import ChangesHistoryButton from './changes-history/ChangesHistoryButton'
import PropertiesTab from './tabs/PropertiesTab'
import RubricsTab from './tabs/RubricsTab'
import './question-drawer.scss'

const QuestionDrawer = () => {
    const { modal } = App.useApp()
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    const dispatch = useDispatch()
    const { token } = useParams()
    const versionId = useVersionId()
    const [form] = Form.useForm()
    const [activeTab, setActiveTab] = useState('properties')

    const {
        data: question,
        isFetching,
        error,
    } = useFetchQuestionsQuery(
        { token, versionId },
        {
            selectFromResult: result => fetchQuestionsSelectors.byId({ id: editingQuestionId }, result),
        },
    )

    const handleClose = () => {
        if (form.isFieldsTouched()) {
            modal.confirm({
                title: 'Unsaved Changes',
                content: 'You have unsaved changes. Are you sure you want to close?',
                okText: 'Yes, close',
                cancelText: 'No, keep editing',
                onOk() {
                    dispatch(questionActions.setEditingQuestionId(null))
                },
            })
        } else {
            dispatch(questionActions.setEditingQuestionId(null))
        }
    }

    const tabs = [
        { key: 'properties', label: 'Properties' },
        { key: 'rubrics', label: 'Rubrics' },
    ]

    const renderTabContent = () => {
        switch (activeTab) {
            case 'properties':
                return <PropertiesTab form={form} />
            case 'rubrics':
                return <RubricsTab question={question} />
            default:
                return null
        }
    }

    const renderTabBar = () => (
        <div style={{ marginLeft: 16, borderBottom: 'none' }}>
            <Tabs
                activeKey={activeTab}
                onChange={setActiveTab}
                size="small"
                items={tabs.map(tab => ({ key: tab.key, label: tab.label }))}
                tabBarExtraContent={<ChangesHistoryButton />}
            />
        </div>
    )

    const content = renderTabContent()

    return (
        <ResizableDrawer
            title={
                renderTabBar()
            }
            open
            autoFocus
            onClose={handleClose}
            mask={null}
            zIndex={8000}
        >
            <Spin spinning={isFetching} tip='Loading question...'>
                {error ? <Alert message={error} type='error' showIcon /> : content}
            </Spin>
        </ResizableDrawer>
    )
}

export default QuestionDrawer
